import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { siteInfo } from '../../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Accueil', path: '/' },
    { name: 'À propos', path: '/about' },
    { name: 'Créations', path: '/creations' },
    { name: 'Événements & Workshops', path: '/events' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'glass-effect shadow-lg py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/btmr9mu6_image.png"
              alt="Tevaite Créations Florales"
              className="h-12 md:h-14 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative font-medium text-sm tracking-wide transition-colors duration-300 ${
                  isActive(link.path)
                    ? 'text-[#8B4B7C]'
                    : 'text-[#6B5A62] hover:text-[#8B4B7C]'
                }`}
              >
                {link.name}
                {isActive(link.path) && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-[#C45B9F] rounded-full" />
                )}
              </Link>
            ))}
          </nav>

          {/* Phone & Menu */}
          <div className="flex items-center space-x-4">
            <a
              href={`tel:${siteInfo.phone}`}
              className="hidden md:flex items-center space-x-2 text-[#8B4B7C] hover:text-[#C45B9F] transition-colors duration-300"
            >
              <Phone size={18} />
              <span className="text-sm font-medium">{siteInfo.phone}</span>
            </a>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 text-[#8B4B7C] hover:text-[#C45B9F] transition-colors duration-300"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div
        className={`lg:hidden absolute top-full left-0 right-0 glass-effect shadow-lg transition-all duration-300 overflow-hidden ${
          isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="flex flex-col py-4 px-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMenuOpen(false)}
              className={`py-3 font-medium transition-colors duration-300 border-b border-[#E8A5C4]/20 last:border-0 ${
                isActive(link.path)
                  ? 'text-[#8B4B7C]'
                  : 'text-[#6B5A62] hover:text-[#8B4B7C]'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <a
            href={`tel:${siteInfo.phone}`}
            className="flex items-center space-x-2 py-3 text-[#8B4B7C]"
          >
            <Phone size={18} />
            <span className="font-medium">{siteInfo.phone}</span>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
